<app-spinner-service></app-spinner-service>

<div class="dividendos-form" [class.dividendos-form--loading]="isCalculando || isSalvando">
  <p-steps [model]="passosFormulario" [activeIndex]="indicePassoAtivo" [readonly]="true" class="passos-formulario"></p-steps>

  <p-message *ngIf="alertaLucrosAcumulados" severity="warn" [text]="alertaLucrosAcumulados" class="mensagem-contexto"></p-message>

  <p-message *ngIf="exibirOrientacaoContabilRegular" severity="info" class="mensagem-contexto"
    text="Ao salvar, o sistema gera automaticamente os lançamentos contábeis: Débito em Lucros Acumulados e Crédito em Dividendos a Pagar.">
  </p-message>

  <p-message *ngIf="exibirOrientacaoContabilAntecipacao" severity="info" class="mensagem-contexto"
    text="Ao salvar, o sistema gera automaticamente os lançamentos contábeis: Débito em Antecipação de Dividendos e Crédito em Caixa/Banco.">
  </p-message>

  <p-message *ngIf="exibirOrientacaoExtrato" severity="info" class="mensagem-contexto"
    text="Com transferência bancária e data de pagamento informada, o sistema classifica automaticamente as linhas correspondentes no extrato como Dividendo.">
  </p-message>

  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-calendar"></i>
      Dados da Distribuição
    </legend>

    <div class="grid">
      <div class="col-12 md:col-4 campo-formulario">
        <label for="dataDistribuicao">Data de Distribuição <span class="required">*</span></label>
        <p-calendar
          inputId="dataDistribuicao"
          [(ngModel)]="dataDistribuicao"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          placeholder="dd/mm/aaaa"
          styleClass="w-full">
        </p-calendar>
        <small class="field-hint"><i class="pi pi-info-circle"></i> Data da deliberação ou registro da distribuição.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario">
        <label for="dataPagamento">Data de Pagamento</label>
        <p-calendar
          inputId="dataPagamento"
          [(ngModel)]="dataPagamento"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          appendTo="body"
          placeholder="dd/mm/aaaa"
          styleClass="w-full">
        </p-calendar>
        <small class="field-hint" *ngIf="formaPagamento === FormaPagamentoDividendoEnum.TransferenciaBancaria">
          <i class="pi pi-info-circle"></i> Necessária para classificar o extrato bancário como Dividendo.
        </small>
        <small class="field-hint" *ngIf="formaPagamento !== FormaPagamentoDividendoEnum.TransferenciaBancaria">
          <i class="pi pi-info-circle"></i> Opcional. Indica quando o pagamento foi ou será realizado.
        </small>
      </div>

      <div class="col-12 md:col-4 campo-formulario campo-somente-leitura">
        <label for="statusReinf">Status REINF</label>
        <input pInputText id="statusReinf" value="Não enviado" readonly class="w-full campo-exibicao-input" />
        <small class="field-hint"><i class="pi pi-lock"></i> Somente leitura. Atualizado automaticamente após envio ao REINF.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario">
        <label for="formaPagamento">Forma de Pagamento</label>
        <p-dropdown
          inputId="formaPagamento"
          [options]="formasPagamento"
          [(ngModel)]="formaPagamento"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="w-full">
        </p-dropdown>
        <small class="field-hint"><i class="pi pi-info-circle"></i> Define como os sócios receberão o dividendo.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario">
        <label for="formaDistribuicao">Forma de Distribuição</label>
        <p-dropdown
          inputId="formaDistribuicao"
          [options]="formasDistribuicao"
          [(ngModel)]="formaDistribuicao"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          styleClass="w-full"
          (onChange)="onFormaDistribuicaoChange()">
        </p-dropdown>
        <small class="field-hint"><i class="pi pi-info-circle"></i> Impacta os lançamentos contábeis gerados automaticamente.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario">
        <label for="valorBrutoTotal">Valor Bruto Total <span class="required">*</span></label>
        <p-inputNumber
          inputId="valorBrutoTotal"
          [(ngModel)]="valorBrutoTotal"
          mode="decimal"
          locale="pt-BR"
          prefix="R$ "
          [minFractionDigits]="0"
          [maxFractionDigits]="2"
          [useGrouping]="true"
          [allowEmpty]="true"
          [showButtons]="false"
          [min]="0"
          inputStyleClass="dividendos-input-numero"
          styleClass="w-full input-numero-wrapper"
          placeholder="0,00"
          (onBlur)="onValorBrutoBlur()">
        </p-inputNumber>
        <small class="field-hint"><i class="pi pi-info-circle"></i> Digite apenas números. Ao sair do campo, IR e valores líquidos são calculados.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario campo-calculado">
        <label for="valorIrTotal">Valor de IR</label>
        <p-inputNumber
          inputId="valorIrTotal"
          [(ngModel)]="valorIrTotal"
          mode="currency"
          currency="BRL"
          locale="pt-BR"
          [disabled]="true"
          styleClass="w-full"
          [ngClass]="'calculated-field-disabled'">
        </p-inputNumber>
        <small class="field-hint field-hint--calculado" *ngIf="isCalculando"><i class="pi pi-spin pi-spinner"></i> Calculando...</small>
        <small class="field-hint field-hint--calculado" *ngIf="!isCalculando"><i class="pi pi-calculator"></i> Calculado automaticamente. Somente leitura.</small>
      </div>

      <div class="col-12 md:col-4 campo-formulario campo-calculado">
        <label for="valorLiquidoTotal">Valor Líquido Total</label>
        <p-inputNumber
          inputId="valorLiquidoTotal"
          [(ngModel)]="valorLiquidoTotal"
          mode="currency"
          currency="BRL"
          locale="pt-BR"
          [disabled]="true"
          styleClass="w-full"
          [ngClass]="'calculated-field-disabled'">
        </p-inputNumber>
        <small class="field-hint field-hint--calculado" *ngIf="isCalculando"><i class="pi pi-spin pi-spinner"></i> Calculando...</small>
        <small class="field-hint field-hint--calculado" *ngIf="!isCalculando"><i class="pi pi-calculator"></i> Calculado automaticamente. Somente leitura.</small>
      </div>
    </div>
  </fieldset>

  <fieldset class="form-fieldset">
    <legend class="form-block-legend">
      <i class="pi pi-users"></i>
      Beneficiários
    </legend>

    <div class="modo-distribuicao mb-3 campo-formulario">
      <label class="modo-distribuicao__label">Distribuição entre beneficiários</label>
      <div class="flex flex-wrap gap-3 mt-2">
        <div *ngFor="let modo of modosDistribuicao" class="flex align-items-center">
          <p-radioButton
            [inputId]="'modo-' + modo.value"
            name="modoDistribuicao"
            [value]="modo.value"
            [(ngModel)]="modoDistribuicao"
            (onClick)="onModoDistribuicaoChange()">
          </p-radioButton>
          <label [for]="'modo-' + modo.value" class="ml-2">{{ modo.label }}</label>
        </div>
      </div>
      <small class="field-hint"><i class="pi pi-info-circle"></i> Proporcional usa a participação societária; individualizado permite valores por sócio.</small>
    </div>

    <p-table [value]="beneficiarios" responsiveLayout="scroll" styleClass="tabela-beneficiarios">
      <ng-template pTemplate="header">
        <tr>
          <th>Sócio</th>
          <th *ngIf="modoDistribuicao === ModoDistribuicaoBeneficiarioEnum.Proporcional">Participação (%)</th>
          <th *ngIf="modoDistribuicao === ModoDistribuicaoBeneficiarioEnum.Individualizado">Valor Bruto</th>
          <th>Valor Bruto</th>
          <th>IR</th>
          <th>Líquido</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-beneficiario>
        <tr>
          <td>{{ beneficiario.nomeSocio }}</td>
          <td *ngIf="modoDistribuicao === ModoDistribuicaoBeneficiarioEnum.Proporcional">
            <p-inputNumber
              [(ngModel)]="beneficiario.percentual"
              mode="decimal"
              locale="pt-BR"
              suffix=" %"
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              [allowEmpty]="true"
              [showButtons]="false"
              [useGrouping]="false"
              [min]="0"
              [max]="100"
              inputStyleClass="dividendos-input-numero"
              styleClass="input-numero-wrapper"
              (onBlur)="onBeneficiarioBlur()">
            </p-inputNumber>
          </td>
          <td *ngIf="modoDistribuicao === ModoDistribuicaoBeneficiarioEnum.Individualizado">
            <p-inputNumber
              [(ngModel)]="beneficiario.valorBruto"
              mode="decimal"
              locale="pt-BR"
              prefix="R$ "
              [minFractionDigits]="0"
              [maxFractionDigits]="2"
              [useGrouping]="true"
              [allowEmpty]="true"
              [showButtons]="false"
              [min]="0"
              inputStyleClass="dividendos-input-numero"
              styleClass="input-numero-wrapper"
              placeholder="0,00"
              (onBlur)="onBeneficiarioBlur()">
            </p-inputNumber>
          </td>
          <td class="td-exibicao">
            <span class="valor-exibicao" [class.valor-calculando]="isCalculando">{{ beneficiario.valorBruto | currency:'BRL' }}</span>
          </td>
          <td class="td-exibicao">
            <span class="valor-exibicao" [class.valor-calculando]="isCalculando">{{ beneficiario.valorIr | currency:'BRL' }}</span>
          </td>
          <td class="td-exibicao">
            <span class="valor-exibicao" [class.valor-calculando]="isCalculando">{{ beneficiario.valorLiquido | currency:'BRL' }}</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="modoDistribuicao === ModoDistribuicaoBeneficiarioEnum.Proporcional ? 5 : 5">
            Nenhum sócio cadastrado. Cadastre sócios em Gestão de Sócios antes de distribuir dividendos.
          </td>
        </tr>
      </ng-template>
    </p-table>

    <small class="p-error block mt-2" *ngIf="mensagemValidacao">
      <i class="pi pi-exclamation-triangle"></i> {{ mensagemValidacao }}
    </small>
  </fieldset>

  <fieldset class="form-fieldset resumo-bloco" *ngIf="indicePassoAtivo === 2">
    <legend class="form-block-legend">
      <i class="pi pi-check-circle"></i>
      Revisão
    </legend>
    <div class="resumo-grid">
      <div><strong>Distribuição:</strong> {{ formaDistribuicaoDescricao }}</div>
      <div><strong>Pagamento:</strong> {{ formaPagamentoDescricao }}</div>
      <div><strong>Bruto:</strong> {{ (valorBrutoTotal ?? 0) | currency:'BRL' }}</div>
      <div><strong>IR:</strong> {{ valorIrTotal | currency:'BRL' }}</div>
      <div><strong>Líquido:</strong> {{ valorLiquidoTotal | currency:'BRL' }}</div>
      <div><strong>Beneficiários:</strong> {{ beneficiarios.length }}</div>
    </div>
  </fieldset>

  <div class="form-actions">
    <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" [disabled]="isSalvando" (click)="voltar()"></button>
    <button
      pButton
      [label]="modoRetificacao ? 'Salvar Retificação' : 'Salvar'"
      icon="pi pi-check"
      class="p-button-success"
      [disabled]="!formularioProntoParaSalvar || isSalvando"
      (click)="salvar()">
    </button>
  </div>
</div>
